import React from 'react';
import { useParams } from 'react-router';
import { useAccountProfile } from 'queries/account';
import {
  useGetNextUpdateTime,
  useGetStatusUpdateTemplateQuery,
} from 'queries/templates/status-update-templates';
import { findNextupdate } from './asu-utils';
import { StatusUpdatesTemplateDetails } from './status-update-template';

interface Params {
  templateId: string;
}

export const StatusUpdatesTemplateDetailPage =
  (): React.ReactElement | null => {
    const { templateId } = useParams<Params>();
    const templId = parseInt(templateId, 10);
    const { data: template } = useGetStatusUpdateTemplateQuery(templId);
    const { data: account } = useAccountProfile();

    const { data, isLoading: isNextUpdateTimeLoading } =
      useGetNextUpdateTime(templId);
    const serverNextPublishAt = data?.nextPublishAt
      ? findNextupdate(data.nextPublishAt, account?.timeZone)
      : null;

    return template && !isNextUpdateTimeLoading ? (
      <StatusUpdatesTemplateDetails
        template={template}
        serverNextPublishAt={serverNextPublishAt}
      />
    ) : null;
  };

export { NewStatusUpdatesTemplatePage } from './new-status-update-template';
